import React, { Component } from 'react';
import { Row, Col, Card, Alert } from 'antd';
import FsdoInformationVerification from 'components/registration/fsdo/FsdoInformationVerification';
import FsdoRequestSubmission from 'components/registration/fsdo/FsdoRequestSubmission';

export default class FsdoSubmitConfirmation extends Component {
    constructor(props) { super(props); }
    render() {
        const { submitStep } = this.props.fsdo.fsdoInfo;
        switch(submitStep) {
            case 0: return <FsdoInformationVerification {...this.props} />;
            case 1: return <FsdoRequestSubmission {...this.props} />;
        }
    };
}
